<div class="dashboard">
  <app-admin-header />
  <div class="container">
    <app-left-navigation />
    <div class="overflow-auto w-full h-full">
      <router-outlet />
    </div>
  </div>
</div>
